/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import Config from "data/config";

export const msalConfig = Config.Azure.msalConfig;

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
    scopes: [
        "openid", // subject populated
        "offline_access", // allows refresh tokens
        "email", // provides email address
        "profile", // provides larger profile
        "User.Read",
        // encodeURIComponent(process.env.REACT_APP_SIMPLICITY_CMS_APPID),
        // encodeURIComponent(process.env.REACT_APP_AZURE_STORAGE_CONTAINER),
        // encodeURIComponent('https://storage.azure.com/.default'),
        // encodeURIComponent('https://storage.azure.com/user_impersonation'),
        // Config.AzureStorage.STORAGE_ACCOUNT_URL
    ],
};

// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};
